import { render, staticRenderFns } from "./linshiyonggong.vue?vue&type=template&id=54866179&scoped=true&"
import script from "./linshiyonggong.vue?vue&type=script&lang=js&"
export * from "./linshiyonggong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54866179",
  null
  
)

export default component.exports